
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "@/components/ui/sonner";

const ShareTarget = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (loading) return;

    if (!user) {
      // Redirect to login if not authenticated
      toast.error("You need to be logged in to share content");
      navigate("/auth", { replace: true });
      return;
    }

    // Get shared data from URL parameters
    const params = new URLSearchParams(location.search);
    const sharedTitle = params.get("title") || "";
    const sharedText = params.get("text") || "";
    const sharedUrl = params.get("url") || "";

    // Prepare content for the new entry
    const initialContent = [
      sharedText,
      sharedUrl ? `Source: [${sharedUrl}](${sharedUrl})` : ""
    ].filter(Boolean).join("\n\n");

    // Redirect to new entry page with the shared content
    navigate("/dashboard/new-entry", {
      state: {
        initialTitle: sharedTitle,
        initialContent,
        source: "share"
      },
      replace: true
    });
  }, [user, loading, navigate, location.search]);

  return (
    <div className="h-screen flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-xl font-medium mb-2">Processing shared content...</h1>
        <p className="text-muted-foreground">Please wait, you'll be redirected shortly.</p>
      </div>
    </div>
  );
};

export default ShareTarget;
